import { createIcon } from '../shared'

const SendIcon = createIcon(
  ({ color }) => (
    <path
      d="M14.9248 1.57666L2.07812 5.98124L6.4827 8.18352L11.9884 4.51304L7.95089 10.0188L10.5202 14.4233L14.9248 1.57666Z"
      fill={color}
    />
  ),
  '0 0 16 16',
  'SendIcon',
)

export { SendIcon }
